module.exports = __webpack_public_path__ + "img/logo.f7203b7e.svg";